import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
//import {useTranslation} from "react-i18next"
import {
  TextField,
  Button,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
//import { set } from "lodash-es"
import { useMutation } from "@apollo/client";
import { ALL_MUNICONFIG, EDIT_MUNICONFIG, DELETE_MUNICONFIG } from "../queries";
import { useQuery } from "@apollo/client";
import kunnat from "kunnat";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";

// Images
import bgImage from "assets/images/admin.png";
import MuniconfigForm from "./MuniconfigForm";
//import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Muniadmin = ({ setError, selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  // eslint-disable-next-line
  const [actived, setActived] = useState("");
  // eslint-disable-next-line
  const [id, setId] = useState("");
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState("");
  const [votefilter, setVotefilter] = useState(false);
  const [strategyfilter, setStrategyfilter] = useState(false);
  const [initiativefilter, setInitiativefilter] = useState(false);
  const [active, setActive] = useState("");
  const [login, setLogin] = useState(true);
  const [text, setText] = useState("");
  const [roles, setRoles] = useState("");
  const [strategytext, setStrategytext] = useState("");
  const [strategycomments, setStrategycomments] = useState(false);
  const [strategyswot, setStrategyswot] = useState(false);
  const [strategyfocusareas, setStrategyfocusareas] = useState(false);
  const [strategymap, setStrategymap] = useState(false);
  const [strategycommentcategories, setStrategycommentcategories] = useState("");
  const [strategyfocusareacategories, setStrategyfocusareacategories] = useState("");
  const [strategybudget, setStrategybudget] = useState(false);
  //console.log(setId);
  //console.log(setActived);
  //console.log(actived);
  //console.log(id);
  //const [email, setEmail] = useState("");
  const [municonfigs, setMuniconfigs] = useState([]);
  //const [t] = useTranslation("common");
  const municonfigss = useQuery(ALL_MUNICONFIG, {
    pollInterval: 1000000,
  });

  useEffect(() => {
    let municonfigsss = [];
    //let municipalitiess = [];
    if (municonfigss.data) {
      municonfigsss = municonfigss.data.allMuniconfigs;
      //setOrgans(organss);
      //console.log(municonfigsss);
      setMuniconfigs(municonfigsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [municonfigss]);

  const [deleteMuniconfig] = useMutation(DELETE_MUNICONFIG, {
    refetchQueries: [{ query: ALL_MUNICONFIG }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment);
    }*/
  });
  const setDelete = async (event) => {
    //event.preventDefault();
    ////console.log(event);
    deleteMuniconfig({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  const [editMuniconfig] = useMutation(EDIT_MUNICONFIG, {
    refetchQueries: [{ query: ALL_MUNICONFIG }],
    // eslint-disable-next-line
    onError: (error) => {
      //setError(error.graphQLErrors[0].message);
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {;
      updateCacheWith(response.data.addComment);
    }*/
  });
  const saveEdit = async () => {
    //event.preventDefault();
    ////console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setEdit(false);
    editMuniconfig({
      variables: {
        name: name,
        datetime: pvm.toString(),
        votefilter: votefilter,
        strategyfilter: strategyfilter,
        initiativefilter: initiativefilter,
        active: active,
        login: login,
        text: text,
        roles: roles,
        strategytext: strategytext,
        strategycomments: strategycomments,
        strategyswot: strategyswot,
        strategyfocusareas: strategyfocusareas,
        strategymap: strategymap,
        strategycommentcategories: strategycommentcategories,
        strategyfocusareacategories: strategyfocusareacategories,
        strategybudget: strategybudget,
      },
    });
    //muutetaan activated !actived edituser
  };
  const getKunnat = (kunn) =>
    kunn.map((kunt) => {
      return (
        <MenuItem value={kunt.name} key={kunt.name}>
          {kunt.name}
        </MenuItem>
      );
    });
  /*const submit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    const aika = Date.now();
    const pvm = new Date(aika);
    createMuniconfig({
      variables: {
        name: name,
        datetime: pvm.toString(),
        votefilter: votefilter,
        strategyfilter: strategyfilter,
        initiativefilter: initiativefilter,
        active: active,
        text: text,
        strategytext: strategytext,
        strategycomments: strategycomments,
        strategyswot: strategyswot,
        strategyfocusareas: strategyfocusareas,
        strategymap: strategymap,
        strategycommentcategories: strategycommentcategories,
        strategyfocusareacategories: strategyfocusareacategories,
        strategybudget: strategybudget,
      },
    });
    //sectionid: sectionid.length > 0 ? sectionid : "tyhjä";
    
  };*/
  const getEdit = (kunn) => {
    //console.log(kunn);
    setEdit(true);
    let prop = municonfigs.filter((a) => a.name === kunn);
    //console.log(prop);
    setVotefilter(prop[0].votefilter);
    setStrategyfilter(prop[0].strategyfilter);
    setInitiativefilter(prop[0].initiativefilter);
    setName(prop[0].name);
    setActive(prop[0].active);
    setLogin(prop[0].login);
    setText(prop[0].text);
    setRoles(prop[0].roles);
    setStrategytext(prop[0].strategytext);
    setStrategycomments(prop[0].strategycomments);
    setStrategyswot(prop[0].strategyswot);
    setStrategyfocusareas(prop[0].strategyfocusareas);
    setStrategymap(prop[0].strategymap);
    setStrategybudget(prop[0].strategybudget);
    setStrategycommentcategories(prop[0].strategycommentcategories);
    setStrategyfocusareacategories(prop[0].strategyfocusareacategories);
  };
  if (edit) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h3>Muokkaa</h3>
                <br />
                <br />
              </MKTypography>
              <br />
              <br />
              <table>
                <tr>
                  <td>name</td>
                  <td>
                    <FormControl fullWidth>
                      <InputLabel id="municipality">Kunta</InputLabel>
                      <Select
                        labelId="muni-select-label"
                        id="muni-select"
                        value={name}
                        label="Kunta"
                        onChange={(target) => setName(target.value)}
                        style={{ backgroundColor: "white" }}
                      >
                        {getKunnat(kunnat)}
                      </Select>
                    </FormControl>
                  </td>
                </tr>
                <tr>
                  <td>votefilter</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={votefilter}
                      checked={votefilter}
                      onChange={() => setVotefilter(!votefilter)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategyfilter</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategyfilter}
                      checked={strategyfilter}
                      onChange={() => setStrategyfilter(!strategyfilter)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>initiativefilter</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={initiativefilter}
                      checked={initiativefilter}
                      onChange={() => setInitiativefilter(!initiativefilter)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>active</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={active}
                      checked={active}
                      onChange={() => setActive(!active)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>login</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={login}
                      checked={login}
                      onChange={() => setLogin(!login)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>text</td>
                  <td>
                    <TextField value={text} onChange={({ target }) => setText(target.value)} />
                  </td>
                </tr>
                <tr>
                  <td>roles</td>
                  <td>
                    <TextField value={roles} onChange={({ target }) => setRoles(target.value)} />
                  </td>
                </tr>
                <tr>
                  <td>strategytext</td>
                  <td>
                    <TextField
                      value={strategytext}
                      onChange={({ target }) => setStrategytext(target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategycomments</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategycomments}
                      checked={strategycomments}
                      onChange={() => setStrategycomments(!strategycomments)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategyswot</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategyswot}
                      checked={strategyswot}
                      onChange={() => setStrategyswot(!strategyswot)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategyfocusareas</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategyfocusareas}
                      checked={strategyfocusareas}
                      onChange={() => setStrategyfocusareas(!strategyfocusareas)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategymap</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategymap}
                      checked={strategymap}
                      onChange={() => setStrategymap(!strategymap)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategycommentcategories</td>
                  <td>
                    <TextField
                      value={strategycommentcategories}
                      onChange={({ target }) => setStrategycommentcategories(target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategyfocusareacategories</td>
                  <td>
                    <TextField
                      value={strategyfocusareacategories}
                      onChange={({ target }) => setStrategyfocusareacategories(target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>strategybudget</td>
                  <td>
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={strategybudget}
                      checked={strategybudget}
                      onChange={() => setStrategybudget(!strategybudget)}
                    />
                  </td>
                </tr>
              </table>
              <br />
              <br />
              <Button
                style={{
                  backgroundColor: "#07575B",
                  color: "#C4DFE6",
                  fontSize: "14px",
                }}
                type="submit"
                onClick={() => saveEdit()}
              >
                Save
              </Button>
              <Button
                style={{
                  backgroundColor: "#07575B",
                  color: "#C4DFE6",
                  fontSize: "14px",
                }}
                type="submit"
                onClick={() => setEdit(false)}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#07575B",
                  color: "#C4DFE6",
                  fontSize: "14px",
                }}
                type="submit"
                onClick={() => setDelete(id)}
              >
                Delete
              </Button>
            </Grid>
          </Container>
        </MKBox>
        <MuniconfigForm setError={setError} selectedKunta={selectedKunta} />
      </>
    );
  } else {
    if (municonfigs) {
      return (
        <>
          <MKBox
            minHeight="23vh"
            width="100%"
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "2500px 500px",
              backgroundPosition: "top",
              display: "grid",
              placeItems: "center",
            }}
          />
          <MKBox pt={6} px={1} mt={6}>
            <Container>
              <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
                <MKTypography
                  variant="body1"
                  color="dark"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  <h3>Kuntien asetukset</h3>
                  {municonfigs.map((prop) => (
                    <div key={prop.id}>
                      <tr>
                        <td>name</td>
                        <td>{prop.name}</td>
                      </tr>
                      <tr>
                        <td>votefilter</td>
                        <td>
                          <TextField value={prop.votefilter} />
                        </td>
                      </tr>
                      <tr>
                        <td>strategyfilter</td>
                        <td>
                          <TextField value={prop.strategyfilter} />
                        </td>
                      </tr>
                      <tr>
                        <td>initiativefilter</td>
                        <td>
                          <TextField value={prop.initiativefilter} />
                        </td>
                      </tr>
                      <tr>
                        <td>active</td>
                        <td>
                          <TextField value={prop.active} />
                        </td>
                      </tr>
                      <tr>
                        <td>login</td>
                        <td>
                          <TextField value={prop.login} />
                        </td>
                      </tr>
                      <tr>
                        <td>text</td>
                        <td>{prop.text}</td>
                      </tr>
                      <tr>
                        <td>roles</td>
                        <td>{prop.roles}</td>
                      </tr>
                      <tr>
                        <td>strategytext</td>
                        <td>{prop.strategytext}</td>
                      </tr>
                      <tr>
                        <td>strategycomments</td>
                        <td>
                          <TextField value={prop.strategycomments} />
                        </td>
                      </tr>
                      <tr>
                        <td>strategyswot</td>
                        <td>
                          <TextField value={prop.strategyswot} />
                        </td>
                      </tr>
                      <tr>
                        <td>strategyfocusareas</td>
                        <td>
                          <TextField value={prop.strategyfocusareas} />
                        </td>
                      </tr>
                      <tr>
                        <td>strategymap</td>
                        <td>
                          <TextField value={prop.strategymap} />
                        </td>
                      </tr>
                      <tr>
                        <td>strategycommentcategories</td>
                        <td>{prop.strategycommentcategories}</td>
                      </tr>
                      <tr>
                        <td>strategyfocusareacategories</td>
                        <td>{prop.strategyfocusareacategories}</td>
                      </tr>
                      <tr>
                        <td>strategybudget</td>
                        <td>
                          <TextField value={prop.strategybudget} />
                        </td>
                      </tr>
                      <Button
                        style={{
                          backgroundColor: "#07575B",
                          color: "#C4DFE6",
                          fontSize: "14px",
                        }}
                        type="submit"
                        onClick={() => getEdit(prop.name)}
                      >
                        Edit
                      </Button>
                      <Button
                        style={{
                          backgroundColor: "#07575B",
                          color: "#C4DFE6",
                          fontSize: "14px",
                        }}
                        type="submit"
                        onClick={() => setDelete(prop.id)}
                      >
                        Delete
                      </Button>
                      <br />
                      <br />
                    </div>
                  ))}
                </MKTypography>
              </Grid>
            </Container>
          </MKBox>
          <MuniconfigForm setError={setError} selectedKunta={selectedKunta} />
        </>
      );
    } else {
      return (
        <>
          <MKBox
            minHeight="23vh"
            width="100%"
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "2500px 500px",
              backgroundPosition: "top",
              display: "grid",
              placeItems: "center",
            }}
          />
          <MKBox pt={6} px={1} mt={6}>
            <Container>
              <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
                <MKTypography
                  variant="body1"
                  color="dark"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  Ei kuntien asetuksia
                </MKTypography>
              </Grid>
            </Container>
          </MKBox>
          <MuniconfigForm setError={setError} selectedKunta={selectedKunta} />
        </>
      );
    }
  }
};
export default Muniadmin;
/**
 * 
 * 
 * 
 * {municonfigs.map((prop) => (
                  <div key={prop.id}>
                    name
                    <FormControl fullWidth>
                      <InputLabel id="municipality">Kunta</InputLabel>
                      <Select
                        labelId="muni-select-label"
                        id="muni-select"
                        value={prop.name}
                        label="Kunta"
                        style={{ backgroundColor: "white" }}
                      >
                        {getKunnat(kunnat)}
                      </Select>
                    </FormControl>
                    <br />
                    <br />
                    votefilter
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.votefilter}
                    />
                    <br />
                    <br />
                    strategyfilter
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategyfilter}
                    />
                    <br />
                    <br />
                    initiativefilter
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.initiativefilter}
                    />
                    <br />
                    <br />
                    active
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.active}
                    />
                    <br />
                    <br />
                    text
                    <TextField value={prop.text} />
                    <br />
                    <br />
                    strategytext
                    <TextField value={prop.strategytext} />
                    <br />
                    <br />
                    strategycomments
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategycomments}
                    />
                    <br />
                    <br />
                    strategyswot
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategyswot}
                    />
                    <br />
                    <br />
                    strategyfocusareas
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategyfocusareas}
                    />
                    <br />
                    <br />
                    strategymap
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategymap}
                    />
                    <br />
                    <br />
                    strategycommentcategories
                    <TextField value={prop.strategycommentcategories} />
                    <br />
                    <br />
                    strategyfocusareacategories
                    <TextField value={prop.strategyfocusareacategories} />
                    <br />
                    <br />
                    strategybudget
                    <Checkbox
                      style={{ backgroundColor: "grey" }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={prop.strategybudget}
                    />
                    <br />
                    <br />
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      type="submit"
                      onClick={() => setDelete(prop.id)}
                    >
                      Delete
                    </Button>
                    <br />
                    <br />
                  </div>
                ))}
 */
